/* eslint-disable max-len */
import lessRequire from '../../config/less-require-resolver';

import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import isEmpty from 'lodash/isEmpty';

import { actions, selectors } from '../user-api';

import renderViewsState from '../shared/render-views-state';
import Manager from '../shared/manager';

const images = require.context('../../apps/rocket/assets/img/postback-info', true);

lessRequire('modules/postback-info/main.less');

const Main = renderViewsState(({ intl, user, manager }) => {
	return (
		<div className='container__with-columns container postback-info'>
			<div className='column_left container__content' hidden={intl.language !== 'ru'}>
				<div className='container__content-title'>
					<h2 className='font-proxima-nova-bold'>
						Что такое постбек в арбитраже и как его правильно настроить в Rocketprofit
					</h2>
				</div>

				<div className='container__content-block'>
					Вероятно, многим знаком термин постбек, но не все понимают что это за фича и для чего она нужна. Даже арбитражники со стажем не всегда в курсе этого функционала и его преимуществ. Пришло время во всем разобраться и расставить точки над “i”.
				</div>
				<div className='container__content-block'>
					Постбек (postback) – механизм с помощью которого партнерка передает данные сторонним сервисам, таким как трекеры. Если быть более точными, это ссылка, которая содержит информацию о совершенных конверсиях.
				</div>
				<div className='container__content-block'>
					Благодаря постбэку вебмастер может получить больше инфы о трафике и более детально проанализировать свою рекламную кампанию. А в дальнейшем – оптимизировать свои объявления и сделать их еще более эффективными.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Настроить постбек в Rocketprofit достаточно просто, есть несколько вариантов его добавления:
					</h3>
					<ul>
						<li>
							<h3 className='font-proxima-nova-semibold'>
								Глобальный – настраивается сразу для всех офферов
							</h3>
							<img src={images('./ru/1.png')} />
						</li>
						<li>
							<h3 className='font-proxima-nova-semibold'>
								Локальный (в потоке) – настраивается под конкретный поток
							</h3>
							<img src={images('./ru/2.png')} />
							<img src={images('./ru/3.png')} />
						</li>
					</ul>
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						В чем различия:
					</h3>
					<ul>
						<li>
							В глобальном можно прописать два постбэка, в локальном только один.
						</li>
						<li>
							Локальный имеет приоритет над глобальным постбэком. Если вы настраиваете локальный постбек в определенном потоке, то срабатывать будет именно он, а не глобальный постбек.
						</li>
					</ul>
				</div>
				<div className='container__content-block'>
					Большой плюс использования глобального постбэка, что его можно прописать один раз и и он будет срабатывать для всех ваших потоков.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Варианты отправки информации по лидам используя постбек:
					</h3>
					<ul>
						<li>
							Постбэк при смене статуса – будет срабатывать постбек при смене каждого статуса – “pending” – ожидает обработки, “approved” – подтверждено, “rejected” – отклонено, “trash” – невалидный.
						</li>
						<li>
							Не слать постбек по лидам в статусе trash (работает в связке с Постбек при смене статуса) – будет отправляться информация по заказам в статусе pending, approved и rejected.
						</li>
						<li>
							Лиды в статусе "approved" – данные будут отправляться только по подтвержденным заказам в статусе approved.
						</li>
						<li>
							Лиды в статусе "pending", Лиды в статусе "rejected", Лиды в статусе "trash", без смены статусов – название само говорит за себя.
						</li>
						<li>
							Слать выплату только по апрувнутым лидам – доступно для подключения только в локальном постбеке.
						</li>
						<li>
							Не слать постбек по restricted регионам – не будет отправляться информация по заказам из restricted регионов.
						</li>
						<li>
							Постбек при смене payout-а –будет отправляться информация, если изменен payout(размер выплаты).
						</li>
						<li>
							Необходимые данные можно получить используя макросы, которые прописываются через знак &.
						</li>
					</ul>
				</div>
				<div className='container__content-block'>
					В  Rocketprofit вы можете передавать следующие макросы:
					<img src={images('./ru/4.png')} />
				</div>
				<div className='container__content-block'>
					Метки <b>от sid1 до sid5</b> предназначены для передачи кастомной, нужной вам информации, к нам в ПП и т.д. Метка <b>sid5</b> обычно занимается автоматически, при выгрузке промо с потока. Сделано это для более удобной интеграции с трекером Keitaro. Если вы используете другой трекер или сервис, то можно использовать в том числе и метку <b>sid5</b>. Если вы используете в качестве трекера - <b>Keitaro</b>, то метку <b>sid5</b> оставить как есть.
				</div>
				<div className='container__content-block'>
					Например, постбек ссылки для передачи суммы заработка и clickID будет выглядеть следующим образом: http://example.com/mystat.php?myprofit=&#123;payout&#125;&clickid=&#123;sid1&#125;
				</div>
				<div className='container__content-block'>
					В момент перехода макросы &#123;payout&#125; и &#123;sid1&#125; будут заменены на соответствующие значения.
				</div>
				<div className='container__content-block'>
					Если вдруг вам нужно переотправить какие-то постбеки, у нас есть удобный раздел для этого в Глобальном постбеке – Переотправка постбека.
				</div>
				<div className='container__content-block'>
					Здесь можно выбрать определенный поток, конверсию и дату для переотправки заказов:
					<img src={images('./ru/5.png')} />
				</div>
				<div className='container__content-block'>
					Надеемся, что информация была полезной для вас и вы сможете грамотно воспользоваться ею, чтобы оптимизировать свои РК и лить только в плюс.
				</div>
			</div>

			<div className='column_left container__content' hidden={intl.language === 'ru'}>
				<div className='container__content-title'>
					<h2 className='font-proxima-nova-bold'>
						What is postback in arbitrage and how to set it up correctly in Rocketprofit
					</h2>
				</div>

				<div className='container__content-block'>
					Many people are probably familiar with the term postback, but not everyone understands what this feature is and why we need it. Even experienced affiliate managers are not familiar with its functionality and advantages. Let's figure it out and make it clear once and for all.
				</div>
				<div className='container__content-block'>
					Postback is a mechanism through which an affiliate program transmits data to third-party services, such as trackers. To be more precise, this is a link that contains information about the conversions made.
				</div>
				<div className='container__content-block'>
					Thanks to postback, a webmaster can get more information about traffic and analyze the advert campaign in more detail. Moreover, it gives an opportunity to optimize own ads and make them even more effective.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Setting up postback in Rocketprofit is quite simple; you can add it in several ways:
					</h3>
					<ul>
						<li>
							<h3 className='font-proxima-nova-semibold'>
								Global – can be configured for all offers at once
							</h3>
							<img src={images('./en/1.png')} />
						</li>
						<li>
							<h3 className='font-proxima-nova-semibold'>
								Local (in-stream) – configured for a specific stream
							</h3>
							<img src={images('./en/2.png')} />
							<img src={images('./en/3.png')} />
						</li>
					</ul>
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						What are the differences:
					</h3>
					<ul>
						<li>
							In the global one you can register two postbacks, in the local one only one.
						</li>
						<li>
							Local has priority over global postback. If you set up a local postback in a certain stream, it will be the one that triggers, and not the global postback.
						</li>
					</ul>
				</div>
				<div className='container__content-block'>
					The major advantage of using global postback is that it can be configured once and will work for all your streams.
				</div>
				<div className='container__content-block'>
					<h3 className='font-proxima-nova-semibold'>
						Options for sending information about leads using postback:
					</h3>
					<ul>
						<li>
							Postback when changing status – postback will be triggered every time the status is changed – “pending” – awaiting processing, “approved” – confirmed, “rejected” – denied, “trash” – invalid.
						</li>
						<li>
							Do not send postback for leads in trash status (works in conjunction with Postback when the status changes) - information on orders in pending, approved and rejected status will be sent.
						</li>
						<li>
							Leads with the "approved" status – data will be sent only for confirmed orders with the approved status.
						</li>
						<li>
							Leads with the "pending" status, Leads with the "rejected" status, Leads with the "trash" status, without changing status – the name speaks for itself.
						</li>
						<li>
							To send payout only for approved leads – available only in local postback.
						</li>
						<li>
							Do not send postback for restricted regions – information on orders from restricted regions will not be sent.
						</li>
						<li>
							Postback when changing payout -information will be sent if the payout (amount of payment) is changed.
						</li>
						<li>
							The necessary data can be obtained using macros, written using the & sign.
						</li>
					</ul>
				</div>
				<div className='container__content-block'>
					You can transfer the following macros in Rocketprofit:
					<img src={images('./en/4.png')} />
				</div>
				<div className='container__content-block'>
					Tags <b>from sid1 to sid5</b> are meant to transfer custom information you need to our CPA, etc. <b>Sid5</b> tag is usually engaged automatically when uploading a promo from the stream. This is done for more convenient integration with Keitaro tracker. If you use another tracker or service, you can also use <b>sid5</b> tag. If you use <b>Keitaro</b> as your tracker, then leave <b>sid5</b> tag as it is.
				</div>
				<div className='container__content-block'>
					For example, postback links for transferring earnings amount and clickID will look like this: http://example.com/mystat.php?myprofit=&#123;payout&#125;&clickid=&#123;sid1&#125;
				</div>
				<div className='container__content-block'>
					At the moment of transition, the macros &#123;payout&#125; and &#123;sid1&#125; will be replaced with the corresponding values.
				</div>
				<div className='container__content-block'>
					If you suddenly need to resend certian postbacks, there is a convenient option for this in the Global Postback - Resending a postback.
				</div>
				<div className='container__content-block'>
					Here you can select a specific stream, conversion, and date to resend orders:
					<img src={images('./en/5.png')} />
				</div>
				<div className='container__content-block'>
					We hope you found this information useful and will be able to use it competently to optimize your ads and drive traffic profitably.
				</div>
			</div>

			<div className='column_right'>
				{!isEmpty(manager) && (
					<Manager
						data={manager}
						user={user}
						intl={intl}
					/>
				)}
			</div>
		</div>
	);
});

export default connect(
	state => ({
		manager: selectors.getManager(state),
		user: selectors.getUserData(state),
		data: selectors.getData(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/postback-info/main.js